import { render } from "./table-entities.vue?vue&type=template&id=5216afa8&ts=true"
import script from "./table-entities.ts?vue&type=script&lang=ts&external"
export * from "./table-entities.ts?vue&type=script&lang=ts&external"

import "./table-entities.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__